export default __webpack_public_path__ + "static/media/lock.03e853de.svg";